import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 일반 - 휴가 신청 등록
export const postVacations = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/request", body)
      .then((res) => {
        toast.success('휴가 신청이 완료되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 일반 - 나의 휴가 목록
export const getVacationsMyList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/my/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 일반 - 누군가의 휴가 목록
export const getVacationsSomeList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/some/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 관리자 - 전 직원 휴가 목록
export const getVacationsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 관리자 - 휴가 개별 수정 및 추가 (MENU - 휴가 부여 현황 - 휴가정보)
export const getVacationsCalculateList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/calculate/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 휴가 현황 목록 다운로드
export const getVacationsCalculateListDownloads = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/calculate/list/downloads", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 관리자 - 휴가 변경 이력 목록 (MENU - 휴가 부여 현황 - 변경이력)
export const getVacationsHistoriesList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/histories/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 관리자 - 휴가 변경 이력 목록 다운로드
export const getVacationsHistoriesListDownloads = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/vacations/histories/list/downloads", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 연차 휴가 수정
export const modifyVacationsLeave = (body) => {
  return new Promise((resolve, reject) => {
    http
      .put("/vacations/leave", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타 휴가 등록 수정 삭제
export const modifyVacationsOthersUpdates = (body) => {
  return new Promise((resolve, reject) => {
    http
      .put("/vacations/others/updates", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};